import {
  createBaseUserParameters,
  updateParametersWithSearch,
} from '../../../srcCommon/inboxes/search/searchHelpers';
import {
  SearchQueryTrackingOptions,
  trackSearchQuery,
} from '../../components/inboxes/search/searchTrackingHelpers';
import {ConversationSortPropertiesEnum} from '../../models/api/conversationCommonTypes';
import {ThunkAction} from '../appThunk';
import {getUserId} from '../data/teammates/teammatesSelectors';
import {CellsContext} from '../panels/cells/context/cellsContext';
import {getCellsSearchQueryHash} from '../panels/cells/search/cellsPanelSearchSelectors';
import {
  InboxesConversationsParameters,
  InboxesParametersTypesEnum,
  InboxesSearchParameters,
} from '../panels/inboxes/parameters/inboxesParameters';
import {buildParametersPath} from '../panels/inboxes/parameters/inboxesParametersPathHelpers';
import {getFlatPanels} from '../panels/panelsSelectors';
import {panelIsCellsPanel} from '../panels/panelsState';
import {navigateToLinkAction} from './navigationActions';

/*
 * Types.
 */

export type SearchInteractionOptions = Pick<SearchQueryTrackingOptions, 'isPasted' | 'isFolderSwitch'>;

/*
 * Action creators.
 */

export function searchByParametersAction(
  searchParameters: InboxesSearchParameters | undefined,
  cellsContext?: CellsContext,
  options?: SearchInteractionOptions,
  sortProperty?: ConversationSortPropertiesEnum,
): ThunkAction {
  return (dispatch, getState) => {
    // Get the parameters for the cells panel current page.
    const state = getState();
    const panels = getFlatPanels(state);
    const panel = panels.find(panelIsCellsPanel);
    const parameters = panel && panel.pages.current && panel.pages.current.parameters;
    if (!parameters) {
      return;
    }

    // If in a messages folder, go to the corresponding conversations folder.
    const baseParameters =
      parameters.type !== InboxesParametersTypesEnum.TEAMMATE_MESSAGES
        ? parameters
        : createBaseUserParameters(getUserId(state), parameters.folder, sortProperty);

    // Update parameters with search.
    const newParameters: InboxesConversationsParameters = updateParametersWithSearch(
      baseParameters,
      searchParameters,
    );

    if (searchParameters) {
      const queryHash = getCellsSearchQueryHash(state);

      const trackingOptions = {
        queryText: searchParameters.query,
        queryHash,
        location: searchParameters.location,
        ...options,
      };

      trackSearchQuery(trackingOptions, parameters, cellsContext);
    }

    const url = buildParametersPath(newParameters);
    dispatch(navigateToLinkAction(url));
  };
}
